import { SVGProps } from 'react'

export const JusAILogo = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_36_62586)">
        <path
          d="M21.0739 0H10.998C10.6167 0 10.2898 0.280196 10.2234 0.662439L9.95448 2.22946C9.95448 2.22946 9.95107 2.24157 9.95107 2.24676L8.07684 13.1398H12.3768C12.6696 13.1398 12.9369 13.3024 13.0748 13.5636L17.8957 22.8204C17.8957 22.8204 17.9536 22.9346 17.9723 23.0245C17.9842 23.0833 17.9893 23.1248 17.9927 23.1577C17.9927 23.1611 17.9927 23.1646 17.9927 23.1698C17.9927 23.1836 17.9927 23.194 17.9927 23.2044C17.9927 23.2407 17.9927 23.2788 17.9927 23.2788C17.991 23.3047 17.9876 23.3306 17.9825 23.3549C17.9859 23.3445 17.9876 23.3341 17.9893 23.3237L21.5812 2.52522L21.8552 0.940905C21.9386 0.447968 21.5658 0 21.0739 0Z"
          fill="#FFCC00"
        />
        <path
          d="M6.35914 23.386V23.3825C6.35574 23.36 6.35233 23.3375 6.35063 23.3133C6.35063 23.3098 6.35063 23.3064 6.35063 23.3012C6.35063 23.2804 6.34723 23.258 6.34723 23.2372C6.34723 23.2303 6.34723 23.2216 6.34723 23.2147C6.34723 23.1957 6.34723 23.1784 6.34893 23.1594C6.34893 23.1455 6.35233 23.1334 6.35404 23.1196C6.35404 23.1058 6.35744 23.0919 6.35914 23.0781C6.36255 23.0504 6.36936 23.0227 6.37446 22.9933L8.07506 13.1398H2.28725C1.69315 13.1415 1.31353 13.7866 1.59441 14.3194L6.41532 23.5762C6.41532 23.5762 6.42043 23.5831 6.42213 23.5883C6.39319 23.526 6.37106 23.4586 6.35914 23.386Z"
          fill="#3D82DA"
        />
        <path
          d="M17.9927 23.2787C17.962 23.7163 17.5586 24.0051 17.2232 24H16.6632H7.15245C7.02138 24 6.88519 23.9654 6.88519 23.9654C6.46813 23.8512 6.27066 23.4586 6.3745 22.9933L8.0751 13.1398H12.3751C12.6679 13.1398 12.9352 13.3024 13.073 13.5635L17.8939 22.8204C17.8939 22.8204 17.9518 22.9345 17.9706 23.0245C17.9893 23.1144 17.9927 23.1663 17.9927 23.2043C17.9927 23.2424 17.9927 23.2787 17.9927 23.2787Z"
          fill="#77B340"
        />
      </g>
      <defs>
        <clipPath id="clip0_36_62586">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
